import { useAtom, useAtomValue } from "jotai"
import { partnerAtom } from "../atoms/partner"

export const usePartnerAtom = () => useAtom(partnerAtom)

export const usePartnerAtomValue = () => useAtomValue(partnerAtom)
